import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { IncompleteStepsModal } from "../../../components/incomplete-steps-modal";
import { UploadDocumentType } from "../../../types";
import { DebtAgreementsDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const DebtAgreementsDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction, applicationSubmit, documentError } = useDocumentNavigationActions({
    forType: UploadDocumentType.COMPANY_DEBT_AGREEMENT,
  });

  return (
    <>
      <IncompleteStepsModal {...applicationSubmit} />
      <OnboardingLayout
        variant="wide"
        title={intl.formatMessage(MESSAGES.debtAgreementsTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <DebtAgreementsDocumentUpload error={documentError} />
        </Flex>
      </OnboardingLayout>
    </>
  );
};
